import axios from 'axios';
import SwalToast from '../components/Common/SwalToast';
import API_ENDPOINTS from '../const/ApiEndpoints';

export const intializeAxios = () => {
  const showLoaderEvent = new Event('showLoader', { bubbles: true });
  const hideLoaderEvent = new Event('hideLoader', { bubbles: true });
  let numberOfApiCallsPending = 0;

  axios.interceptors.request.use(
    function (config) {
      const token = localStorage.getItem('ACCESS_TOKEN') || '';
      if (token) {
        // eslint-disable-next-line no-param-reassign
        config.headers.Authorization = `Bearer ${token}`;
      }
      numberOfApiCallsPending += 1;
      if (config?.loader === false) {
        numberOfApiCallsPending = 0;
        document.dispatchEvent(hideLoaderEvent);
      } else {
        document.dispatchEvent(showLoaderEvent);
      }
      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    function (response) {
      numberOfApiCallsPending -= 1;
      if (numberOfApiCallsPending <= 0) {
        numberOfApiCallsPending = 0;
        setTimeout(() => {
          document.dispatchEvent(hideLoaderEvent);
        }, 400);
      }
      if (response?.headers?.['x-info'] === 'True') {
        SwalToast({
          icon: 'info',
          title: response?.data?.message || 'Info',
        });
      }
      return response;
    },
    async (error) => {
      let errorMessage = error?.message;

      if (error?.response?.data?.error) {
        if (typeof error.response.data.error === 'string') {
          errorMessage = error.response.data.error;
        } else {
          errorMessage = JSON.stringify(error.response.data.error);
        }
      }

      numberOfApiCallsPending -= 1;
      if (numberOfApiCallsPending === 0) {
        setTimeout(() => {
          document.dispatchEvent(hideLoaderEvent);
        }, 400);
      }

      if (error.response) {
        if (
          error.response.status === 401 &&
          error.config.url !== API_ENDPOINTS.BASE_URL + API_ENDPOINTS.AUTH_LOGIN
        ) {
          localStorage.removeItem('ACCESS_TOKEN');
          window.location.href = '/login';
        }
      }
      if (
        error?.config?.url !==
        API_ENDPOINTS.BASE_URL + API_ENDPOINTS.CHECK_ACTIVE_SESSION
      ) {
        if (error?.response?.headers?.['x-info'] === 'True') {
          SwalToast({
            icon: 'info',
            title: errorMessage,
          });
        }
        SwalToast({
          icon: 'error',
          title: errorMessage,
        });
      }
      return Promise.reject(error);
    }
  );
};

export default intializeAxios;
